import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */
const CurrencyIcon = ({ className = '', width = 10,  height = 12 , color = 'currentColor' }) => {
    return (
        <svg
            className={className ? className : ''}
            fill='none'
            height={height}
            viewBox='0 0 10 12'
            width={width}
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M3.128 3.281C3.128 2.091 3.689 1.173 5.066 1.173C6.426 1.173 7.208 2.006 7.225 3.621L8.517 3.553C8.517 1.326 7.208 0 5.015 0C2.924 0 1.683 1.326 1.683 3.264C1.683 3.978 1.853 4.539 2.074 5.066H0.782V6.035H2.516C2.788 6.63 3.009 7.242 3.026 8.024C2.669 7.854 2.295 7.735 1.87 7.735C0.765 7.735 0 8.449 0 9.435C0 10.523 0.816 11.118 1.819 11.118C2.805 11.118 3.468 10.608 3.859 9.86C4.607 10.489 5.474 11.118 6.715 11.118C8.262 11.118 9.163 9.962 9.112 7.973L7.956 7.922C7.956 9.129 7.599 9.877 6.596 9.877C5.627 9.877 4.913 9.333 4.182 8.789C4.233 8.517 4.25 8.245 4.25 7.956C4.25 7.242 4.08 6.63 3.859 6.035H6.137V5.066H3.485C3.281 4.505 3.128 3.944 3.128 3.281ZM1.836 10.2C1.377 10.2 1.02 9.911 1.02 9.435C1.02 8.942 1.343 8.653 1.87 8.653C2.227 8.653 2.584 8.84 2.924 9.095C2.788 9.775 2.448 10.2 1.836 10.2Z'
                fill={color}/>
        </svg>

    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default CurrencyIcon;
